import { Component, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { CartProvider } from "@/lib/cart";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import PopUpShop from "@/pages/PopUpShop";
import ShopWithinShop from "@/pages/ShopWithinShop";
import BeautyRentals from "@/pages/BeautyRentals";
import Events from "@/pages/Events";
import Services from "@/pages/Services";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import Rules from "@/pages/Rules";
import Faq from "@/pages/Faq";
import Book from "@/pages/Book";
import Admin from "@/pages/Admin";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div style={{ padding: "42vh 24px 0", textAlign: "center", fontFamily: "Jost, sans-serif" }}>
          Something went wrong. <a href="/" style={{ textDecoration: "underline" }}>Go home</a>.
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function LenisOnce() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
    let raf = requestAnimationFrame(function loop(t) {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    });
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
}

function Layout({ children }) {
  const { pathname } = useLocation();
  const bare = pathname.startsWith("/admin");
  if (bare) return <>{children}</>;
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
      <CartDrawer />
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <CartProvider>
          <ScrollToTop />
          <LenisOnce />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/pop-up-shop" element={<PopUpShop />} />
              <Route path="/shop-within-a-shop" element={<ShopWithinShop />} />
              <Route path="/beauty-rentals" element={<BeautyRentals />} />
              <Route path="/events" element={<Events />} />
              <Route path="/services" element={<Services />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/about" element={<About />} />
              <Route path="/rules" element={<Rules />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/book" element={<Book />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </Layout>
        </CartProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
